// removed by extract-text-webpack-plugin
module.exports = {"cropperImg":"_34-XABPsqm8pe83H_MIvdW","preview":"_3Nsv00OgT9IlxBI--C9Jek","cropper":"TR6qEfgX2Xv036XSFvzMW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cropper/Cropper.scss
// module id = 1259
// module chunks = 1